var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('MTSHeaderDemoMobile'),_vm._v(" "),_c('section',{staticClass:"base-content"},[_c('Nuxt')],1),_vm._v(" "),_c('ExternalIntegrations'),_vm._v(" "),_c('DataCollection'),_vm._v(" "),_c('div',{staticClass:"popmechanic-disable-flag",class:{ true: _vm.hidePopmechanic }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }